/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { FooterContainer } from "./StyledComponents/FooterElements";

const Footer = () => {

  const { t } = useTranslation();

  return (
    <>
      <FooterContainer>
        <hr className="mt-5 mb-5" />
        <div className="grid grid-cols-3 grid-rows-1 text-sm md:flex justify-center items-center md:pr-16 md:text-md">
          <div className="flex items-center justify-center md:mr-2">
            <a
              className="text-lavanda underline "
              href="https://helppeoplecloud.com/2021/03/24/terminos-y-condiciones-del-servicio/"
              target="_blank"
              rel="noreferrer"
            >
              helppeople
            </a>
          </div>

          <div className="flex items-center justify-center">
            <span>|</span>
            <a
              className="text-lavanda underline mr-3 ml-3"
              href="https://helppeoplecloud.com/2021/03/24/politicas-de-la-seguridad-de-la-informacion/"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.policies")}
            </a>
            <span>|</span>
          </div>

          <div className="flex items-center justify-center md:ml-2">
            <a
              className="text-lavanda underline"
              href="https://helppeoplecloud.com/2021/03/24/politica-de-proteccion-de-datos/"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.privacyPolicy")}
            </a>
            <span>|</span>
          </div>

          <div className="flex items-center justify-center md:ml-2">
            <a className="text-lavanda" rel="noreferrer">
            {t("footer.version")} 2026.01.22
            </a>
          </div>
        </div>
        <div>
          <hr className="mb-5 mt-5" />
        </div>
      </FooterContainer>
    </>
  );
};

export default Footer;
